/**
 * Convert a percentage (range 0.0 to 1.0) to a two-digit hex string.
 *
 * @param pctOpaque percent opacity (range 0.0 - 1.0)
 * @returns two-digit hex code for the opacity
 * @example
 * const eightPctOpacityHex = decimalToHexString(0.82) // output = 'D1'
 * const baseColor = '#FFFFFF'
 *
 * const eightPctOpaqueDiv = styled.div`
 *  background-color: ${baseColor}${eightPctOpacityHex};
 * `
 */
export const decimalToHexString = (pctOpaque) => {
    const safePctOpaque = Math.max(0, Math.min(1, pctOpaque));
    return Math.round(255 * safePctOpaque)
        .toString(16)
        .padStart(2, '0')
        .toUpperCase();
};
//# sourceMappingURL=colors.js.map